// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"7967de4c","415":"f6d917fe","442":"eefe3e42","482":"f663f4ed"}[chunkId] + ".chunk.js";
};